module.exports = __webpack_public_path__ + "static/assets/59abc2c9e616fd9d7fe63ff5b3f67f17.png";